import { Component, Inject } from '@angular/core';
import { DpBottomSheetCloserComponent } from '../../common-component/dp-bottom-sheet-closer/dp-bottom-sheet-closer.component';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-oblate-bottom-sheet',
  standalone: true,
  imports: [DpBottomSheetCloserComponent],
  templateUrl: './add-oblate-bottom-sheet.component.html',
  styleUrl: './add-oblate-bottom-sheet.component.scss'
})
export class AddOblateBottomSheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) private data: any,
    private bottomSheetRef: MatBottomSheetRef<AddOblateBottomSheetComponent>,
    private toastr: ToastrService,
  ){}
  addOblateType: any = [];

  selectedOblateType!: string

  ngOnInit(){
    if(this.data.length > 0){
      if(this.data.includes('dpOffline')){
        this.addOblateType.push(
          {
            title: `Upload DP (Offline)`,
            description: `This method is to upload diksha patras of the ongoing term.`,
            type: 'offline'
          }
        )
      }

      if(this.data.includes('dpOnline')){
        this.addOblateType.push(
          {
            title: `New diksha (Online)`,
            description: `This method is only applicable for real-time initiations. Please check before proceeding!`,
            type: 'online'
          }
        )
      }
    }
  }

  selectedType(value: string){
    this.selectedOblateType = value;
  }

  closesheet():void{
    this.bottomSheetRef.dismiss();
  }

  onSelectAddOblateType(){
    if(this.selectedOblateType){
      this.bottomSheetRef.dismiss(this.selectedOblateType)
    } else {
      this.toastr.error('Select any mode to proceed.')
    }
    
  }

}
